import {computed, Injectable, signal, WritableSignal} from "@angular/core";
import {environment} from "../../environments/environment";
import {BucketConfig} from "@interfaces/general/bucket-config";
import {EnvironmentHtmlContent} from "@interfaces/general/environment-html-content";
import {EnvironmentMercadoPago} from "@interfaces/general/environment-mercado-pago";
import {EnvironmentShipping} from "@interfaces/general/environment-shipping";

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {

  getTitle() {
    return environment.general.title;
  }
  getNameMultiClient() {
    return environment.general.nameMultiClient;
  }
  getLogoUrl() {
    return environment.general.logoUrl;
  }
  getCarouselImages() {
    return environment.general.carouselImages;
  }
  /**
   * Extension de las imagenes del carrusel cuando se arman por convencion.
   * Por defecto jpeg, que es lo que estaba hardcodeado.
   */
  getCarouselExtension(): string {
    return (environment.general as { carouselExtension?: string }).carouselExtension || 'jpeg';
  }

  /**
   * URLs explicitas del carrusel. Si el cliente las declara se usan tal cual,
   * sin depender de que el archivo respete el patron carruselN.ext. Si esta
   * vacio se cae a la convencion de siempre (abaco sigue asi).
   */
  getCarouselUrls(): string[] {
    return (environment.general as { carouselUrls?: string[] }).carouselUrls || [];
  }
  getColumnsItemMobile() {
    return environment.general.columnsItemMobile;
  }
  getUrl() {
    return environment.general.url;
  }

  getBucketConfig(): BucketConfig {
    return environment.bucketConfig;
  }
  getHtmlContent(): EnvironmentHtmlContent {
    return environment.htmlContent;
  }
  getMercadoPago(): EnvironmentMercadoPago {
    return environment.mercadoPago;
  }

  getShipping(): EnvironmentShipping {
    return environment.shipping;
  }

  getValidateStock(): boolean {
    return environment.general.validateStock;
  }

  getLocalPayment(): boolean {
    return environment.localPayment;
  }

  getMobileApp(): boolean {
    return environment.general.mobileApp;
  }

  getEncryptionKey(): string {
    return environment.security.encryptionKey;
  }

  getPaymentServiceUrl(): string {
    return (environment.general as any).paymentServiceUrl;
  }
}
